import { StepIndicator } from 'foundations-components/transitional/components/StepIndicator';
import { StepProgressIndicatorWrapper, StyledStepProgressIndicator } from './StepProgressIndicator.style';
import { jsx as _jsx } from "react/jsx-runtime";
export const StepProgressIndicator = ({
  stepIndex,
  stepNames
}) => {
  return /*#__PURE__*/_jsx(StyledStepProgressIndicator, {
    children: /*#__PURE__*/_jsx(StepProgressIndicatorWrapper, {
      children: /*#__PURE__*/_jsx(StepIndicator, {
        direction: "horizontal",
        stepIndex: stepIndex,
        stepNames: stepNames
      })
    })
  });
};